const units = (num) => {
  switch (num) {
    case 1:
      return 'Un';
    case 2:
      return 'Dos';
    case 3:
      return 'Tres';
    case 4:
      return 'Cuatro';
    case 5:
      return 'Cinco';
    case 6:
      return 'Seis';
    case 7:
      return 'Siete';
    case 8:
      return 'Ocho';
    case 9:
      return 'Nueve';
    default:
      break;
  }

  return '';
};

const tensAnd = (str, unitsNumber) => {
  if (unitsNumber > 0) return `${str} Y ${units(unitsNumber)}`;

  return str;
};

const switche = (unitsSubs) => {
  let res = '';
  switch (unitsSubs) {
    case 0:
      res = 'Diez';
      break;
    case 1:
      res = 'Once';
      break;
    case 2:
      res = 'Doce';
      break;
    case 3:
      res = 'Trece';
      break;
    case 4:
      res = 'Catorce';
      break;
    case 5:
      res = 'Quince';
      break;
    default:
      res = `Dieci${units(unitsSubs).toLowerCase()}`;
      break;
  }
  return res;
};

const tens = (num) => {
  const tensDivide = Math.floor(num / 10);
  const unitsSubs = num - tensDivide * 10;
  let value = '';
  switch (tensDivide) {
    case 1:
      value = switche(unitsSubs);
      break;
    case 2:
      if (unitsSubs === 0) {
        value = 'Veinte';
      }
      value = `Veinti${units(unitsSubs).toLowerCase()}`;
      break;
    case 3:
      value = tensAnd('Treinta', unitsSubs);
      break;
    case 4:
      value = tensAnd('Cuarenta', unitsSubs);
      break;
    case 5:
      value = tensAnd('Cincuenta', unitsSubs);
      break;
    case 6:
      value = tensAnd('Sesenta', unitsSubs);
      break;
    case 7:
      value = tensAnd('Setenta', unitsSubs);
      break;
    case 8:
      value = tensAnd('Ochenta', unitsSubs);
      break;
    case 9:
      value = tensAnd('Noventa', unitsSubs);
      break;
    case 0:
      value = units(unitsSubs);
      break;
    default:
      break;
  }
  return value;
};

const hundreds = (num) => {
  const hundredsDivide = Math.floor(num / 100);
  const tensSub = num - hundredsDivide * 100;

  switch (hundredsDivide) {
    case 1:
      if (tensSub > 0) return `Ciento ${tens(tensSub)}`;
      return 'Cien';
    case 2:
      return `Doscientos ${tens(tensSub)}`;
    case 3:
      return `Trescientos ${tens(tensSub)}`;
    case 4:
      return `Cuatrocientos ${tens(tensSub)}`;
    case 5:
      return `Quinientos ${tens(tensSub)}`;
    case 6:
      return `Seisientos ${tens(tensSub)}`;
    case 7:
      return `Setecientos ${tens(tensSub)}`;
    case 8:
      return `Ochocientos ${tens(tensSub)}`;
    case 9:
      return `Novecientos ${tens(tensSub)}`;
    default:
      break;
  }

  return tens(tensSub);
};

const section = (num, divider, strSingular, strPlural) => {
  const hundredsDivide = Math.floor(num / divider);
  const restSub = num - hundredsDivide * divider;

  let letters = '';

  if (hundredsDivide > 0) {
    if (hundredsDivide > 1) letters = `${hundreds(hundredsDivide)} ${strPlural}`;
    else letters = strSingular;
  }

  if (restSub > 0) letters += '';

  return letters;
};

const thousands = (num) => {
  const divider = 1000;
  const hundredsDivide = Math.floor(num / divider);
  const restSub = num - hundredsDivide * divider;

  const strThousands = section(num, divider, 'Un Mil', 'Mil');
  const strHundreds = hundreds(restSub);

  if (strThousands === '') return strHundreds;

  return `${strThousands} ${strHundreds}`;
};

const millions = (num) => {
  const divider = 1000000;
  const hundredsDivide = Math.floor(num / divider);
  const restSub = num - hundredsDivide * divider;

  const strMillions = section(num, divider, 'Un Millon de', 'Millones de');
  const strThousands = thousands(restSub);

  if (strMillions === '') return strThousands;

  return `${strMillions} ${strThousands}`;
};

const numberToLetter = (number, config) => {
  const defaults = {
    currency: 'Pesos',
    cent: 'Centavos',
  };

  if (config) {
    Object.keys(config).forEach((key) => { defaults[key] = config[key]; });
  }

  const data = {
    number,
    ints: Math.floor(number),
    cents: Math.round(number * 100) - Math.floor(number) * 100,
    centLetters: '',
    currencyLetter: defaults.currency,
    currencyLetterSingular: defaults.currency.slice(0, -1),
    centsLetterPlural: defaults.cent,
    centsLetterSingular: defaults.cent.slice(0, -1),
  };

  if (data.cents > 0) {
    data.centLetters = `con ${
      (function a() {
        if (data.cents === 1) return `${millions(data.cents)} ${data.centsLetterSingular}`;
        return `${millions(data.cents)} ${data.centsLetterPlural}`;
      }())}`;
  }

  if (data.ints === 0) return `Cero ${data.currencyLetter} ${data.centLetters}`;
  if (data.ints === 1) return `${millions(data.ints)} ${data.currencyLetterSingular} ${data.centLetters}`;
  return `${millions(data.ints)} ${data.currencyLetter} ${data.centLetters}`;
};

export default numberToLetter;
